import { Theme, ThemeProvider, TooltipProps } from '@mui/material';
import { getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';

import CustomTooltip from './CustomTooltip';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';

export default (element: HTMLElement) => {
  const root = createRoot(element);
  const theme = getTheme({
    app: THEME_APP_NAME,
    branding: window.branding,
    isRounded: false,
    mode: 'light',
  }) as Theme;

  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <ThemeProvider theme={theme}>
        <CustomTooltip
          icon={element.dataset.icon && JSON.parse(element.dataset.icon)}
          text={element.dataset.text || ''}
          placement={element.dataset.placement as TooltipProps['placement'] || 'top'}
        />
      </ThemeProvider>
    </ErrorBoundary>,
  );
};

